import { createApp } from 'vue'
import routerConfig from './router'
import store from './store'
import './css/main.css'
import VueSelect from "vue-select"
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import Sugar from 'sugar'
import Swal from 'sweetalert2'
import FloatingVue from 'floating-vue'
import { media } from '@/utilities/utils'
import mixpanel from 'mixpanel-browser'
import { LocalStorage } from 'ttl-localstorage'
import base from '@/api/base'
import 'floating-vue/dist/style.css'
import "vue-select/dist/vue-select.css"
import { registerSW } from 'virtual:pwa-register'
import mitt from 'mitt'

registerSW({ immediate: true })
LocalStorage.runGarbageCollector()

// sugar 時刻を日本にする
Sugar.extend()
import('sugar/locales/ja').then(() => {
    Date.setLocale('ja')
})

const { appComponent, router } = routerConfig

/* Collapse mobile aside menu on route change */
// ページ遷移の直前にする処理
router.beforeEach((to) => {
    store.dispatch('asideLgToggle', false)
})

/* Default title tag */
const defaultDocumentTitle = 'SPO+ Training'

const isAdmin = !!localStorage.getItem('spo+admin_token')

router.beforeEach(async (to, from) => {
    // ログイン後はログイン画面に戻させない
    if (to.name === 'login') {
        if(import.meta.env.PROD) {
            window.location.replace('/top/#/login?redirect=/training/#'+to.path)
            return
        }
        const token = LocalStorage.get('spoplus-token')
        if (token) {
            return {
                name: 'home',
                replace: true
            }
        }
        return
    }

    // デバッグ用
    if (to.query.forceview === 'true') {
        return
    }
    try {
        const response = await base.get('session', {}, true)
        // console.log('session', response)
        if (response.token) {
            if (response.user.is_coach) {
                if (import.meta.env.PROD) {
                    window.location.replace('/coach/')
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'コーチです'
                    })
                }
                return
            }
            LocalStorage.put('spoplus-token', response.token, 60 * 60 * 24 * 3) //ログインキャッシュの有効期限3日にした
            // google analytics
            // eslint-disable-next-line no-undef
            gtag('set', 'user_properties', {
                crm_id: response.user.username
            })

            // mixpanel
            // if (mixpanelToken) {
            if (!isAdmin && response.user.id) {
                mixpanel.identify(response.user.id)
            }

            // if (!isAdmin && response.team) {
            //     mixpanel.set_group('team', response.team.team_id)
            // }

            // 成功したら、storeに基本データを保存
            // console.log('session成功', response)
            store.commit('setBasicInfo', response)

            if (response.need_userinfo) {
                store.commit('setIsFirstLogin', true)
                if (to.name !== 'userinfoform') {
                    return {
                        name: 'userinfoform',
                        replace: true,
                        params: {
                            need_payment: response.need_payment ? 'need' : 'skip',
                            force: response.force_payment ? 'force' : 'skip'
                        }
                    }
                }
                return
            }

            // store.commit('setUserData', response.user_data)

            // console.log('from', from)
            // console.log('to', to)
            if (response.need_payment) {
                window.location.href = '/top/#/plans'
                return
            }

            // stripe.statusがunpaidの時に、有効なクレカ情報を入力させるページ
            if (response.need_renew_payment) {
                if (to.name !== 'paymentupdate') {
                    if (response.force_renew_payment || !sessionStorage.getItem('skipPayment')) {
                        return {
                            name: 'paymentupdate',
                            replace: true,
                            params: {
                                force: response.force_renew_payment ? 'force' : 'skip'
                            }
                        }
                    }
                } else {
                    if (response.force_renew_payment && (!to.params.force || to.params.force !== 'force')) {
                        return {
                            name: 'paymentupdate',
                            replace: true,
                            params: {
                                force: response.force_renew_payment ? 'force' : 'skip'
                            }
                        }
                    }
                }
                return
            }
        } else {
            LocalStorage.removeKey('spoplus-token')
            sessionStorage.removeItem('skipPayment')
            if(import.meta.env.PROD) {
                window.location.replace('/top/#/login?redirect=/training/#'+to.path)
            } else {
                return {
                    name: 'login',
                    replace: true
                }
            }
        }
    } catch (err) {
        console.log('error!!', err)
        if (err.code === 401) {
            LocalStorage.removeKey('spoplus-token')
            sessionStorage.removeItem('skipPayment')
            if(import.meta.env.PROD) {
                window.location.replace('/top/#/login?redirect=/training/#'+to.path)
            } else {
                return {
                    name: 'login',
                    replace: true
                }
            }
        }
    }
})

// GTMスクリプトを動的に追加
const loadGtmScript = () => {
    return new Promise((resolve) => {
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-K3C6JQ2B'
        script.onload = resolve
        document.head.appendChild(script)
    })
}

// Google Analyticsのスクリプトを動的に追加
const loadGAScript = () => {
    return new Promise((resolve) => {
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-MXW44XSRP1'
        script.onload = () => {
            window.dataLayer = window.dataLayer || []
            window.gtag = function() { window.dataLayer.push(arguments) }
            window.gtag('js', new Date())
            window.gtag('config', 'G-MXW44XSRP1')
            resolve()
        }
        document.head.appendChild(script)
    })
}

// 本番環境の場合のみGoogle AnalyticsとGTMスクリプトを挿入
// if (import.meta.env.PROD) {
Promise.all([loadGtmScript(), loadGAScript()]).then(() => {
    console.log('GTMとGoogle Analyticsがロードされました')
})
// }

router.afterEach((to) => {
    // ページ遷移情報
    mixpanel.track(`enter member page: ${to.meta.title}`)

    if (window.gtag && to.fullPath) {
        window.gtag('config', 'G-MXW44XSRP1', { 'page_path': to.fullPath })
    }

    // GTMのページビューのトラッキング
    if (window.dataLayer) {
        window.dataLayer.push({
            'event': 'pageview',
            'pageTitle': to.meta.title || document.title,
            'pagePath': to.fullPath
        })
    }

    /* Set document title from route meta */
    document.title = to.meta && to.meta.title ?
        `${to.meta.title} — ${defaultDocumentTitle}` :
        defaultDocumentTitle

    // eslint-disable-next-line no-undef
    gtag('event', 'page_view', {
        page_title: document.title,
        page_path: to.path
    })
    /* Full screen mode */
    store.dispatch('fullScreenToggle', !!to.meta.fullScreen)
})

// mixpanel初期設定
mixpanel.init(!isAdmin && import.meta.env.PROD && import.meta.env.VITE_MIXPANEL ? import.meta.env.VITE_MIXPANEL :'DUMMY', {
    debug: !import.meta.env.PROD,
    api_host: 'https://mp.spo-plus.com',
    ignore_dnt: true,
})

// NOTE: カスタムテーマを設定する際は下記の設定が必要らしい。
// https://github.com/Akryum/floating-vue/issues/871#issuecomment-1343296818
FloatingVue.options.themes['team'] = {
    $extend: 'tooltip',
}
FloatingVue.options.themes['national'] = {
    $extend: 'tooltip',
}

const app = createApp(appComponent)
app.component('DatePicker', Datepicker)
app.component("VSelect", VueSelect)


if (import.meta.env.PROD) {
    import('@airbrake/browser').then(module => {
        const ab = new module.Notifier({
            projectId: 414060,
            projectKey: 'f33dafd246e8f5c14a5e5ce62887ce0b',
            environment: 'production'
        })
        const token = LocalStorage.get('spoplus-token')
        ab.addFilter((notice) => {
            if (token) {
                notice.session = {
                    username: store.state.userName,
                    media: media()
                }
            }
            notice.context.version = import.meta.env.PACKAGE_VERSION
            return notice
        })
        app.config.errorHandler = function (err, vm, info) {
            ab.notify({
                error: err,
                params: { info }
            })
        }
        window.addEventListener('error', event => {
            ab.notify({
                error: event.error,
                params: { event }
            })
        })
        app.provide('$ab', ab)
    })
}

const Toast = Swal.mixin({
    toast: true,
    position: media() === 'mobile' ? 'top' : 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const createToast = (text, option) => {
    // let type = option.type
    // type = type === 'danger' ? 'error' : type
    Toast.fire({
        icon: option.type === 'danger' ? 'error' : option.type,
        title: text
    })
}

const emitter = mitt()

app.provide('$toast', createToast)
app.provide('$mixpanel', mixpanel)
app.provide('$emitter', emitter)

// app.provide('$mp', mp)

// safariのキャッシュ対策
// navigator.serviceWorker.getRegistrations()
//     .then(registrations => {
//         for (const registration of registrations) {
//             registration.unregister()
//         }
//     })

app.use(store)
    .use(router)
    .use(VueSweetalert2)
    .use(VuePlyr, {
        plyr: {}
    })
    .use(FloatingVue)
    .mount('#app')
